<template>
  <img v-if="product.image_sizes?.[size]" :src="product.image_sizes?.[size]" :alt="product.alt_image ?? product.name" loading="lazy">
  <img v-else src="/assets/img/placeholder.png?v=2" :alt="product.alt_image ?? product.name" loading="lazy">
</template>

<script>
import ProductImageType from "@/enum/ProductImageType.js";

export default {
  name: 'TheProductImage',
  props: {
    product: {
      type: Object,
      require: true,
    },
    size: {
      require: true,
    },

  },
}
</script>

<style lang="scss" scoped>

</style>